import { HttpError } from '@core/services/http';

export function getHttpError(err: unknown) {
  if (err instanceof HttpError || err instanceof Error) {
    return err;
  }
  return new HttpError('Unknown error', 'Unknown error', 418);
}
